import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as $ from 'jquery';
require('jquery-ui');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');

import { ResponseService } from '../../../../../../services/response.service';

@Component({
    selector: 'associate-interaction',
    template: require('./associate-interaction.html'),
})
export class AssociateInteractionComponent implements OnInit, AfterViewInit {

    @Input() interaction: PgRendererDto.InteractionDefinition;
    associateInteraction: PgRendererDto.AssociateInteraction;
    placeholderPair: PgRendererDto.AssociateInteractionPlaceholderPair[];
    availableChoices: PgRendererDto.SimpleAssociableChoice[];

    constructor(
        private responseService: ResponseService,
        private domSanitizer: DomSanitizer
    ) { }

    ngOnInit() {
        this.associateInteraction = this.interaction.AssociateInteraction;
        const response = this.responseService.getResponse(this.interaction);
        if (response) {
            this.availableChoices = this.interaction.AssociateInteraction.SimpleAssociableChoices.filter(c => response.Items.findIndex(x => x.Value == c.Identifier) < 0);
        } else {
            this.availableChoices = this.interaction.AssociateInteraction.SimpleAssociableChoices;
        }
        this.placeholderPair = [];
        for (let index = 0; index < this.associateInteraction.MinAssociations; index++) {
            this.placeholderPair.push(this.getPlaceholderPair(response, index));
        }
    }

    ngAfterViewInit() {
        $(`.associate-interaction-${this.interaction.InteractionId} .draggable`).draggable({
            revert: "invalid",
            helper: "clone"
        });

        $(`.associate-interaction-${this.interaction.InteractionId} .choice-container`).droppable({
            over: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.addClass("allow-drop");
                }
            },
            out: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.append(ui.draggable);
                    dropTarget.removeClass("no-drop allow-drop");
                    const id = ui.draggable.attr("id");
                    this.removeResponse(id);
                }
            }
        });

        $(`.associate-interaction-${this.interaction.InteractionId} .placeholder`).droppable({
            over: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    const existingDraggable = dropTarget.find(".draggable");
                    if (existingDraggable.length > 0) {
                        if (existingDraggable[0].innerHTML == ui.draggable.html()) {
                            dropTarget.addClass("allow-drop");
                        } else {
                            dropTarget.addClass("no-drop");
                        }
                    } else {
                        dropTarget.addClass("allow-drop");
                    }
                }
            },
            out: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    if (dropTarget.find(".draggable").length < 1) {
                        dropTarget.append(ui.draggable);
                        const id = ui.draggable.attr("id");
                        this.removeResponse(id);
                        this.setResponse(dropTarget.attr("id"), id);
                    }
                }
                dropTarget.removeClass("no-drop allow-drop");
            }
        });
    }

    haveSameParentId(elem1: JQuery, elem2: JQuery): boolean {
        return elem1.data("parentId") == elem2.data("parentId");
    }

    setResponse(key: string, identifier: string) {
        this.responseService.setResponse(this.interaction, key, identifier, null, true, null);
    }

    removeResponse(identifier: string) {
        this.responseService.removeResponseItem(this.interaction.InteractionId, identifier);
    }

    getResponse(mapEntry: PgRendererDto.MapEntry, mapEntryIndex: number, responseIndex: number) {
        const response = this.responseService.getResponse(this.interaction);
        const keys = mapEntry.MapKey.split(" ");
        const choice = this.associateInteraction.SimpleAssociableChoices.find(c => c.Identifier == keys[responseIndex]);
        if (response && choice) {
            const item = response.Items.find(r => r.Key == mapEntryIndex.toString() && r.Value == choice.Identifier);
            if (item) {
                return this.domSanitizer.bypassSecurityTrustHtml(`<span class="draggable" data-id="${choice.Identifier}" data-parent-id="${this.interaction.InteractionId}">${choice.Html}</span>`);
            }
        }
        return "";
    }

    getPlaceholderPair(response: PgRendererDto.InteractionResponse, index: number): PgRendererDto.AssociateInteractionPlaceholderPair {
        let placeholder1, placeholder2;
        if (response) {
            const placeholderItems = response.Items.filter(x => x.Key == index.toString());
            placeholderItems.forEach((r, rIndex) => {
                const choice = this.associateInteraction.SimpleAssociableChoices.find(c => c.Identifier == r.Value);
                if (choice) {
                    if (rIndex == 0) {
                        placeholder1 = {
                            Identifier: choice.Identifier,
                            Html: choice.Html
                        };
                    } else if (rIndex == 1) {
                        placeholder2 = {
                            Identifier: choice.Identifier,
                            Html: choice.Html
                        };
                    }
                }
            });
        }
        return {
            SubKey: index.toString(),
            Placeholder1: placeholder1,
            Placeholder2: placeholder2,
        };
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/associate-interaction/associate-interaction.component.ts